import React, { useState, useEffect, useRef } from "react";
import { Fullscreen2DLayout } from "../layout/Fullscreen2DLayout";
import { IconButton } from "../input/IconButton";
import { ReactComponent as CloseIcon } from "../icons/Close.svg";
import styles from "./IframeLinkModal.scss";
import classNames from "classnames";
import { getMediaType } from "../../utils/custom-utils";
import styles2D from "./2d-media.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faRedo } from "@fortawesome/free-solid-svg-icons";
import PinchZoomPan from "react-responsive-pinch-zoom-pan";

export function IframeLinkModal({ onClose, src, open }) {
  const zoomFactor = 0.2;
  const [pos, setPos] = useState({ x: 0, y: 0, scale: 1 });
  const [showSrc, setShowSrc] = useState(false);
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState("");
  const pdfViewerSrc = src => {
    const DOCS_GOOGLE = "https://docs.google.com/viewer";

    if (src) {
      const url = `${DOCS_GOOGLE}?url=${src}&embedded=true`;

      return url;
    }
    return src;
  };
  const initSrc = async () => {
    await new Promise((resolve, reject) => setTimeout(resolve, 100));
    setShowSrc(true);
  };

  // Is required implement use effect in order to apply inmediately the pointer-events none in root
  // Otherwise camera of user will be moved even if the modal is opened
  useEffect(() => {
    if (src) {
      const getType = getMediaType(src);
      setType(getType);

      initSrc();
    }
  }, [src]);

  const close = () => {
    setShowSrc(false);
    setVisible(false);
    onClose();
  };

  useEffect(() => {
    if (showSrc == true) {
      setVisible(true);
    }
  }, [src]);

  const containerRef = useRef(null);

  const toolbarConfig = toolbars => {
    const keysToUse = ["zoomIn", "zoomOut", "reset"];

    return toolbars
      .filter(toolbar => keysToUse.includes(toolbar.key))
      .map(toolbar => {
        if (toolbar.key == "zoomIn") {
          toolbar.render = <FontAwesomeIcon icon={faPlus} />;
        }
        if (toolbar.key == "zoomOut") {
          toolbar.render = <FontAwesomeIcon icon={faMinus} />;
        }
        if (toolbar.key == "reset") {
          toolbar.render = <FontAwesomeIcon icon={faRedo} />;
        }
        return toolbar;
      });
  };

  const onScroll = e => {
    e.preventDefault();
    if (e.deltaY !== 0) {
      const delta = e.deltaY * -0.01;
      const newScale = pos.scale + delta;

      const ratio = 1 - newScale / pos.scale;

      setPos({
        scale: newScale,
        x: pos.x + (e.clientX - pos.x) * ratio,
        y: pos.y + (e.clientY - pos.y) * ratio
      });
    }
  };

  const zoomIn = () => {
    const newScale = pos.scale + zoomFactor;
    setPos({
      ...pos,
      scale: newScale
    });
  };

  const zoomOut = () => {
    const newScale = pos.scale - zoomFactor;
    if (newScale >= 1) {
      // Ensure that the scale doesn't go below 1
      setPos({
        ...pos,
        scale: newScale
      });
    }
  };

  const onRedo = () => {
    setPos({
      ...pos,
      scale: 1
    });
  };

  return (
    <>
      {open && (
        <Fullscreen2DLayout
          className={classNames(styles.layout, styles.layoutTransparent)}
          contentClassName={styles.content}
          headerClassName={styles.header}
          headerRight={
            type != "image" && (
              <IconButton onClick={close}>
                <CloseIcon fill="white" />
              </IconButton>
            )
          }
          headerRightClassName={styles.headerRight}
        >
          {showSrc && (
            <>
              {type && type == "pdf" && <iframe allowvr="yes" src={pdfViewerSrc(src)}></iframe>}
              {type && type == "image" && (
                <>
                  <div id="image-container" style={{ position: "relative" }} className={styles2D.imageContainer}>
                    <div
                      id="image-viewer"
                      ref={containerRef}
                      style={{ margin: "auto" }}
                      // onWheelCapture={onScroll}
                    >
                      <PinchZoomPan maxScale={2} className="zoom-container">
                        <img
                          src={src}
                          style={{
                            transform: `scale(${pos.scale})`
                          }}
                        />
                      </PinchZoomPan>
                    </div>
                    <div className={styles.closeButton} onClick={close}>
                      <IconButton>
                        <CloseIcon fill="white" />
                      </IconButton>
                    </div>
                  </div>
                </>
              )}
              {type && type == "video" && (
                <div className={styles2D.imageContainer} style={{ margin: "auto" }}>
                  <video controls src={src}></video>
                </div>
              )}
            </>
          )}
        </Fullscreen2DLayout>
      )}
    </>
  );
}
